// src/components/create-project/hooks/useProjectForm.ts
import { useState } from 'react';
import { ProjectFormData } from '../types/project';
import { useProjects } from './useProjects';
import { toast } from 'react-hot-toast';
import { Project } from '../types/project';
export const useProjectForm = (onClose: () => void, onSuccess: (project: Project) => void) => {
  const [isLoading, setIsLoading] = useState(false);
  const [step, setStep] = useState(0);
  const [formData, setFormData] = useState<ProjectFormData>({
    name: '',
    description: '',
    useCases: [],
    contentTypes: [],
    contentStructures: [],
  });
  const [errors, setErrors] = useState<Record<string, string>>({});
  const { addProject } = useProjects();

  const updateField = (key: keyof ProjectFormData, value: any) => {
    setFormData(prev => ({ ...prev, [key]: value }));
    if (errors[key]) setErrors(prev => ({ ...prev, [key]: '' }));
  };

  const validateStep = () => {
    const newErrors: Record<string, string> = {};
    
    switch (step) {
      case 0:
        if (!formData.name.trim()) newErrors.name = 'Project name is required';
        break;
      case 1:
        if (!formData.useCases.length) newErrors.useCases = 'Select at least one use case';
        break;
      case 2:
        if (!formData.contentTypes.length) newErrors.contentTypes = 'Select at least one content type';
        break;
      case 3:
        if (!formData.contentStructures.length) 
          newErrors.contentStructures = 'Select at least one content structure';
        break;
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  
  const handleSubmit = async () => {
    if (!validateStep()) return;
    setIsLoading(true);
    try {
      await addProject(formData);
      toast.success('Project created successfully');
      onSuccess(formData as Project);
    } catch (error) {
      toast.error('Failed to create project');
    } finally {
      setIsLoading(false);
      onClose();
    }
  };

  return {
    step,
    formData,
    errors,
    isLoading,
    setStep,
    updateField,
    validateStep,
    handleSubmit,
  };
};